export const removeArrEle = (arr: Array<any>, index: number) => {
  return arr.slice(0, index).concat(arr.slice(index + 1));
};
